module.exports = __webpack_public_path__ + "static/img/Villaya-Agri-Business_InaugurationGrenoble.f1bd0a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Villaya-Agri-Business_InaugurationGrenoble.jpg
// module id = e64+
// module chunks = 0